export default [
	{
		id: 1,
		type: "text",
		title: "Persönliche Angaben",
		items: [
			{
				id: 1,
				type: "small",
				text: "Semester",
			},
			{
				id: 2,
				type: "medium",
				text: "Studiengang",
			},
		],
	},
	{
		id: 2,
		type: "matwis-p",
		title: "Wie bewerten Sie diese Veranstaltung (in Schulnoten)?",
		rowTitle: "Praktikumsversuch",
		items: [
			{
				id: 3,
				text: "Fehlerrechnung (Motz, Betreuer/in: Jutta Luksch)",
			},
			{
				id: 4,
				text: "Verwendung von Origin (Presser, Betreuer/in: Mohammad Torkamanzadeh)",
			},
			{
				id: 5,
				text: "Numerische Analyse wissenschaftlicher Daten (Müser, Betreuer/in: Joshua Weißenfels)",
			},
			{
				id: 6,
				text: "Numerische Methoden (Müser, Betreuer/in: Christian Müller)",
			},
			{
				id: 7,
				text: "Fischertechnik-Fabrik – Teil 1 (Diebels, Betreuer/in: Dr. Michael Roland)",
			},
			{
				id: 8,
				text: "Fischertechnik-Fabrik – Teil 2 (Diebels, Betreuer/in: Dr. Michael Roland)",
			},
			{
				id: 9,
				text: "Rheologie von Fluiden (Falk, Betreuer/in: Laura Krämer)",
			},
			{
				id: 10,
				text: "Thermometrie, Wärmeinhalt (Busch, Betreuer/in: Valeria Lemkova)",
			},
			{
				id: 11,
				text: "Mischungs- und Schmelzwärme (Busch, Betreuer/in: Fabian Vollmers)",
			},
			{
				id: 12,
				text: "Gleichstrom, Ohm, Kirchhoff (Motz, Betreuer/in: Valeria Lemkova)",
			},
			{
				id: 13,
				text: "Wechselstrom, Impedanz, Brücke (Servicestelle MWWT, Betreuer/in: Jürgen Klesen)",
			},
			{
				id: 14,
				text: "Schliffherstellung (Mücklich, Betreuer/in: Michael Kasper)",
			},
		],
	},
	{
		id: 3,
		type: "text",
		items: [
			{
				id: 15,
				text: 'Gerne können Sie auch Lob und Kritik angeben. Insbesondere falls Sie "Sehr gut" oder "Mangelhaft" angekreuzt haben, würde uns der Grund interessieren:',
			},
		],
	},
];
